module.exports = __webpack_public_path__ + "static/media/icon-piece1-1.4d57a515.png";